import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function AlphabeticalIndex() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const sections = [{
    label: 'A → I',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'
  }, {
    label: 'I → M',
    content: 'Integer malesuada nunc vel risus commodo viverra maecenas accumsan. Lacus vel facilisis volutpat est velit egestas dui id ornare. Semper auctor neque vitae tempus quam pellentesque nec nam aliquam. Lobortis mattis aliquam faucibus purus in massa tempor nec.'
  }, {
    label: 'M → S',
    content: 'Morbi tristique senectus et netus et malesuada fames ac turpis. Sagittis scelerisque purus semper eget duis at tellus at urna. Pellentesque habitant morbi tristique senectus et netus et malesuada. Sit amet porttitor eget dolor morbi non arcu risus quis.'
  }, {
    label: 'S → W',
    content: 'Suspendisse interdum consectetur libero id faucibus nisl tincidunt eget. Vitae congue mauris rhoncus aenean vel elit scelerisque. Wisi enim ad minim veniam, quis nostrud exercitation ullamco laboris. Sed vulputate odio ut enim blandit volutpat maecenas.'
  }];
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-8 bg-gray-100" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="flex flex-wrap justify-center gap-4" data-id="element-16">
          {sections.map((section, index) => <div key={index} className="flex-1 min-w-[140px] max-w-[280px]" data-id="element-17">
              <button onClick={() => toggle(index)} className="w-full flex items-center justify-center gap-2 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-colors" data-id="element-18">
                <span className="underline" data-id="element-19">{section.label}</span>
                <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-20" />
              </button>
              {openIndex === index && <div className="mt-2 p-4 bg-white border border-gray-200 rounded-lg text-sm text-gray-600 leading-relaxed shadow-sm" data-id="element-21">
                  {section.content}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}